import React, { ReactElement, ReactNode } from "react";
import { useRouter } from "next/router";
import { regionContent } from '@kursk/content/regionContent';
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import { chars } from "@common/utils/constants";
import { ITag } from "@common/redux/types/tags";
import styles from "./CatalogueTitle.module.scss";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { localesSlice } from "@common/redux/slices/locales.slice";
import { eventsPlacesSlice } from "@common/redux/slices/eventsPlaces.slice";
import { streamsPlacesSlice } from "@common/redux/slices/streamsPlaces.slice";
import { getQueryFilter } from "@common/query/queryFilter";
import { Page } from "@kursk/components/seo/seo.types";
import { FiltersSeo, getFiltersSeo } from "@kursk/components/seo/utils";
import { useOrientations } from "@common/hooks/useOrientation";

interface CatalogueTitleProps {
  tags?: ITag[],
  selectedTags?: number[],
  title?: string,
  dashTitle?: string,
  total?: number,
  page?: Page,
  genres?: ITag[],
  withSwitchMap?: boolean,
  switchMapComponent?: ReactNode | ReactElement | ReactElement[],
}

export const CatalogueTitle = ({
  tags, selectedTags, title, dashTitle, total, page, genres, withSwitchMap = false, switchMapComponent,
}: CatalogueTitleProps) => {
  const router = useRouter();
  const orientation = useOrientations();
  const seoPages = regionContent.seo.pages;
  const { items: allLocales } = useSelectSlice(localesSlice);
  const { items: allEventPlaces } = useSelectSlice(eventsPlacesSlice);
  const { items: allStreamPlaces } = useSelectSlice(streamsPlacesSlice);

  const newFilters = getQueryFilter(router.query);

  let filtersSeo: FiltersSeo;
  try {
    filtersSeo = getFiltersSeo(
      newFilters, page, seoPages,
      {
        locales: allLocales,
        places: page === 'streams' || page === 'singleStream' ? allStreamPlaces : allEventPlaces,
        tags,
        genres
      }
    );

    // fallback
    if (newFilters && !filtersSeo.h1) {
      filtersSeo = {
        h1: seoPages?.[page]?.h1(),
        title: undefined,
        description: undefined
      };
    }
  } catch (e) {
    filtersSeo = undefined;
  }

  const resultTitle = filtersSeo?.h1 ??
    (tags && selectedTags ? getEntitiesListTitle(tags, selectedTags, title) : title);

  return (
    <>
      <div className={styles.titleWrapper}>
        <h1 className={styles.title}>{resultTitle}</h1>
        {orientation === 'mobile' && withSwitchMap && switchMapComponent}
      </div>

      {dashTitle && (
        <div className={styles.foundWrapper}>
          <p className={styles.found}>
            {dashTitle}&nbsp; {chars.dash}&nbsp; <span className={styles.totalNumber}>{total}</span>
          </p>
          {orientation !== 'mobile' && withSwitchMap && switchMapComponent}
        </div>
      )}
    </>
  )
}
